import { z } from 'zod';

export const PublisherClickId = z.string();

export type PublisherClickId = z.infer<typeof PublisherClickId>;
